// AYRON Complete With — adds the main product's currently selected variant
// plus the chosen complementary variant to the cart in a single request.

function getMainVariantId(mainProductId) {
  const form = document.querySelector(
    `product-form-component[data-product-id="${mainProductId}"]`
  );
  if (!form) return null;
  const input = form.querySelector('[name="id"]');
  return input ? input.value : null;
}

function getSelectedCompleteVariantId(wrapper) {
  const checked = wrapper.querySelector(
    '.ayron-complete-with__variants input[type="radio"]:checked'
  );
  if (checked) return checked.value;

  const first = wrapper.querySelector(
    '.ayron-complete-with__variants input[type="radio"]'
  );
  if (first) return first.value;

  // No variant picker rendered means the complementary product has only
  // one variant; its id is embedded in the add button's dataset fallback.
  return wrapper.dataset.singleVariantId || null;
}

document.addEventListener('change', (event) => {
  const input = event.target.closest(
    '.ayron-complete-with__variants input[type="radio"]'
  );
  if (!input) return;

  const wrapper = input.closest('[data-complete-with]');
  if (!wrapper) return;

  const priceEl = wrapper.querySelector('[data-complete-with-price]');
  if (priceEl && input.dataset.priceFormatted) {
    priceEl.textContent = `+ ${input.dataset.priceFormatted}`;
  }

  const imageEl = wrapper.querySelector('[data-complete-with-image]');
  if (imageEl && input.dataset.image) {
    imageEl.src = input.dataset.image;
    imageEl.srcset = '';
  }
});

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-complete-with-add]');
  if (!button) return;

  const wrapper = button.closest('[data-complete-with]');
  if (!wrapper) return;

  const statusEl = wrapper.querySelector('[data-complete-with-status]');
  const mainProductId = wrapper.dataset.mainProductId;

  const mainVariantId = getMainVariantId(mainProductId);
  const completeVariantId = getSelectedCompleteVariantId(wrapper);

  if (!mainVariantId || !completeVariantId) {
    if (statusEl) {
      statusEl.hidden = false;
      statusEl.dataset.state = 'error';
      statusEl.textContent = 'Impossible de trouver la sélection actuelle.';
    }
    return;
  }

  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = '...';
  if (statusEl) {
    statusEl.hidden = true;
    statusEl.removeAttribute('data-state');
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          { id: parseInt(mainVariantId, 10), quantity: 1 },
          { id: parseInt(completeVariantId, 10), quantity: 1 },
        ],
      }),
    });

    if (!response.ok) {
      const errorBody = await response.json().catch(() => null);
      throw new Error(
        (errorBody && errorBody.description) || 'cart_add_failed'
      );
    }

    // Reload so the header cart bubble and drawer reflect both new items.
    window.location.reload();
  } catch (error) {
    button.disabled = false;
    button.textContent = originalText;
    if (statusEl) {
      statusEl.hidden = false;
      statusEl.dataset.state = 'error';
      statusEl.textContent =
        "Une erreur est survenue lors de l'ajout au panier. Réessayez.";
    }
  }
});
